import React from 'react';
import { ArrowForward } from '@one-thd/sui-icons';
import { Card, CardContent } from '@one-thd/sui-atomic-components';

const StoreHeroWorkshop = () => {
  return (
    <Card grow data-component="StoreHeroWorkshop">
      <CardContent disablePadding>
        <a className="sui-flex sui-justify-around sui-items-center" href="/workshops">
          <img
            style={{ objectFit: 'cover', width: '40px', height: '40px' }}
            alt="DIY Workshops"
            loading="lazy"
            src="https://assets.thdstatic.com/images/v1/diy-workshops.svg"
            width={40}
            height={40}
          />
          <div className="sui-flex sui-flex-col">
            <div className="sui-font-w-bold">Attend a Free Online Workshop</div>
            <div>Home Projects for All Level of Doers</div>
          </div>
          <ArrowForward />
        </a>
      </CardContent>
    </Card>
  );
};

StoreHeroWorkshop.propTypes = {
};

StoreHeroWorkshop.defaultProps = {
};

StoreHeroWorkshop.displayName = 'StoreHeroWorkshop';

export { StoreHeroWorkshop };
